import React from "react";
import "./DeviceConfig/ConfigPane.scss";
import "./JSONHTML.css";
import { Icon } from "react-icons-kit";
import { check } from "react-icons-kit/feather/";
import {
  ic_border_left,
  ic_border_right,
  ic_border_top,
  ic_border_bottom
} from "react-icons-kit/md";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as widgetConfigActions } from "../../../actions/widgetConfigActions";
import { actionCreators as uiActionCreators } from "../../../actions/uiActions";

import PalamToggleSwitch from "../../generic/palam_toggle_switch";
import PalamToggleButton from "../../generic/palam_toggle_button";

import GeneralFormRow from "./GeneralFormRow";

import { specialSettingsForWidgetTypes, widgetTypeNameForWidgetType } from "../../../helpers/constants";

import { withTranslation } from 'react-i18next';

class WidgetSettingsWindow extends React.PureComponent {
  renderSpecialConfig() {
    let { widgetid, thisWidgetConfig, setWidgetSettingsProp, t } = this.props;
    let { widget_type } = thisWidgetConfig;

    let formrows = [];

    let specialSettings = specialSettingsForWidgetTypes[widget_type];



    formrows = specialSettings.map(element => {
      return (
        <GeneralFormRow
          label={t(element.label)}
          key={element.name}
          value={thisWidgetConfig.widgetSettings[element.name]}
          type={element.type}
          options={element.options && element.options.map(x=>t(x))}
          onChange={evt => {
            setWidgetSettingsProp(widgetid, element.name, evt.target.value);
          }}
          onClear={() => {
            setWidgetSettingsProp(widgetid, element.name, undefined);
          }}
        />
      );
    });

    return formrows.length > 0 ? (
      <div className="configpane-section">
        <div className="configpane-section-head">{t("special_word")}</div>
        <div className="configpane-section-content">{formrows}</div>
      </div>
    ) : null;
  }

  render() {
    //
    let {
      widgetid,
      onHide,
      thisWidgetConfig,
      setWidgetSettingsProp,
      t
    } = this.props;
    let { widgetSettings = {}, widget_type } = thisWidgetConfig;

    let widgetTypeName = widgetTypeNameForWidgetType(widget_type, t)
    return (
      <div className="configpane">
        <div className="configpane-head">
          <div className="l" />
            <div className="m">{widgetTypeName}: {t("widget_configuration_label")}</div>
          <div className="r" />
        </div>
        <div className="configpane-inner">
          <div className="configpane-container">
            <div className="configpane-form">
              <div className="configpane-section">
                <div className="configpane-section-head">{t("general_word")}</div>
                <div className="configpane-section-content">
                  <div className="configpane-form-row">
                    <div className="configpane-form-row-label">
                      {t("hide_widget_label_label")}
                    </div>
                    <div className="configpane-form-row-input">
                      <PalamToggleSwitch
                        isActive={widgetSettings.hideWidgetLabel}
                        onClick={() => {
                          setWidgetSettingsProp(
                            widgetid,
                            "hideWidgetLabel",
                            !!!widgetSettings.hideWidgetLabel
                          );
                        }}
                      />
                    </div>
                  </div>

                  <div className="configpane-form-row">
                    <div className="configpane-form-row-label">{t("borders_label")}</div>
                    <div className="configpane-form-row-input">
                      <div className="palam-button-group">
                        <PalamToggleButton
                          isActive={widgetSettings.border_left}
                          onClick={() => {
                            setWidgetSettingsProp(
                              widgetid,
                              "border_left",
                              !!!widgetSettings.border_left
                            );
                          }}
                        >
                          <Icon size={24} icon={ic_border_left} />
                        </PalamToggleButton>
                        <PalamToggleButton
                          isActive={widgetSettings.border_right}
                          onClick={() => {
                            setWidgetSettingsProp(
                              widgetid,
                              "border_right",
                              !!!widgetSettings.border_right
                            );
                          }}
                        >
                          <Icon size={24} icon={ic_border_right} />
                        </PalamToggleButton>
                        <PalamToggleButton
                          isActive={widgetSettings.border_top}
                          onClick={() => {
                            setWidgetSettingsProp(
                              widgetid,
                              "border_top",
                              !!!widgetSettings.border_top
                            );
                          }}
                        >
                          <Icon size={24} icon={ic_border_top} />
                        </PalamToggleButton>
                        <PalamToggleButton
                          isActive={widgetSettings.border_bottom}
                          onClick={() => {
                            setWidgetSettingsProp(
                              widgetid,
                              "border_bottom",
                              !!!widgetSettings.border_bottom
                            );
                          }}
                        >
                          <Icon size={24} icon={ic_border_bottom} />
                        </PalamToggleButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {this.renderSpecialConfig()}
            </div>
          </div>
        </div>
        <div className="configpane-foot">
          <div className="configpane-hide-button" onClick={onHide}>
            <Icon size={36} icon={check} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let { widgetid } = ownProps;
  return {
    thisWidgetConfig: state.widgetConfig[widgetid]
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...uiActionCreators, ...widgetConfigActions },
    dispatch
  );
}

const ConnectedWidgetSettingsWindow = connect(
  mapStateToProps,
  mapDispatchToProps
)(WidgetSettingsWindow);

export default withTranslation()(ConnectedWidgetSettingsWindow);
